import { axios } from "@/libraries/axios";
import type { PresignPayloadSchema } from "@/schemas";
import type { CreateStorageResponse, GetStoragesResponse } from "@/types";
import { fileService } from "./file";

class StorageService {
	get storagesParams() {
		return {
			page: 1,
			limit: 25,
		};
	}

	async storages(params = {}) {
		try {
			const res = await axios.get<GetStoragesResponse>("/api/v1/storages", {
				params: {
					...this.storagesParams,
					...params,
				},
			});
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async create(payload: PresignPayloadSchema[]) {
		try {
			const resPresign = await fileService.presigns(payload);
			const body: Record<"file_id", string>[] = resPresign.map((p) => ({
				file_id: p.fields.key,
			}));
			const res = await axios.post<CreateStorageResponse>("/api/v1/storages", {
				storage: body,
			});
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async remove(id: number) {
		try {
			const res = await axios.delete(`/api/v1/storages/${id}`);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async removes(ids: number[]) {
		try {
			for (const id of ids) {
				await this.remove(id);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async exports(ids: number[]) {
		try {
			const res = await axios.post("/api/v1/storages/export", {
				ids,
			});
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
}

export const storageService = Object.freeze(new StorageService());
